import React from 'react'
import styled from 'styled-components'
import { Block, BlockGroup, Spinner, Text } from '@mote/ui'
import { AccountProfileTheme } from './AccountProfileTheme'
import { useAccountProfileMutation } from '@mote/api'
import { TickOutlineIcon } from '@mote/assets/icons'
import { MOTE_CARD_THEME_TO_GRADIENT_MAP } from '@mote/helpers/constants'

const THEMES = [
  {
    name: 'Classic',
    value: 'classic',
    styles: {
      background: MOTE_CARD_THEME_TO_GRADIENT_MAP.classic,
      placeholderBackground: '#ECECF3'
    }
  },
  {
    name: 'Mulberry',
    value: 'mulberry',
    styles: {
      background: MOTE_CARD_THEME_TO_GRADIENT_MAP.mulberry,
      placeholderBackground: 'rgba(255, 255, 255, 0.2)'
    }
  }
]

export const AccountProfileThemeSelection = ({
  userName,
  currentTheme,
  avatarUrl
}) => {
  const [selectedTheme, setSelectedTheme] = React.useState(currentTheme)

  const { mutate, error, loading, fetched } = useAccountProfileMutation()

  async function handleThemeSelection(newTheme) {
    const oldTheme = selectedTheme
    if (selectedTheme === newTheme) return
    setSelectedTheme(newTheme)

    const res = await mutate({
      variables: {
        theme: { name: newTheme }
      }
    })

    if (res?.error) {
      setSelectedTheme(oldTheme)
    }
  }

  return (
    <Root>
      <Block gap={16}>
        <BlockGroup layout='horizontal' align='center' gap={12}>
          <Text fontWeight={500} fontSize={15} color='#25252D'>
            My theme{' '}
          </Text>
          {loading && (
            <Block layout='horizontal' align='center' gap={5}>
              <Spinner radius={16} />
              <Text
                fontSize={15}
                fontWeight={400}
                lineHeight={24}
                color='#B2B2CC'
              >
                Saving changes
              </Text>
            </Block>
          )}
          {!loading && fetched && (
            <Block layout='horizontal' align='center' gap={5}>
              <TickOutlineIcon />
              <Text
                fontSize={15}
                fontWeight={400}
                lineHeight={24}
                color='#473B4C'
              >
                Changes saved
              </Text>
            </Block>
          )}
          {!loading && error && (
            <Text
              fontSize={15}
              fontWeight={400}
              lineHeight={24}
              color='#F44336'
            >
              Couldn't update your theme preference
            </Text>
          )}
        </BlockGroup>
        <Text color='#716581' fontSize={15} fontWeight={400}>
          Changing your theme will change how your mote appears to others
        </Text>
      </Block>

      <Block layout='horizontal' gap={24} margin='32px 0 0 0' wrapped>
        {THEMES.map(theme => (
          <AccountProfileTheme
            avatarUrl={avatarUrl}
            key={theme.name}
            theme={theme}
            userName={userName}
            isSelected={selectedTheme === theme.value}
            onThemeSelection={handleThemeSelection}
          />
        ))}
      </Block>
    </Root>
  )
}

const Root = styled.div``
